import { createFileRoute } from '@tanstack/react-router'
import { StaffMusrenbang } from '../../../../components/StaffMusrenbang'

export const Route = createFileRoute('/desa/$slug/dashboard/musrenbang')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffMusrenbang desaId={desaId} />
  },
})
